import { defineComponent as _defineComponent } from 'vue'
import { ref, withDefaults } from 'vue';
import { Autocomplete } from 'element-ui';
import { useI18n } from '@/composables/use-i18n';
import { Icon as PtIcon } from 'patsnap-biz';
import Legal from '@/components/legal';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import {
    SearchComparePatent,
    type ComparePatentInfo
} from '@/infrastructure/api-functions/core-search-api/core-search-api-service.interface';
import _ from 'lodash';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import '@patsnap-ui/icon/assets/solid/SearchLeft.svg'
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddPatent',
  props: {
    placeholder: { default: '' },
    showCompareButton: { type: Boolean, default: false }
  },
  emits: ['submit'],
  setup(__props: any, { emit }) {

const props = __props as { placeholder: string, showCompareButton: boolean }

const ElAutocomplete = Autocomplete;
const { t } = useI18n();





const inputVal = ref('');
const isLoading = ref(false);
const isNodata = ref(false);
const patentInfo = ref<ComparePatentInfo>();

const searchPatent = async (queryString:string, cb:(info: ComparePatentInfo[]) => void) => {
    const query = (queryString || '').trim();
    if (!query) return cb([]);

    isLoading.value = true;
    cb([{ isLoading: true }]);

    const service = injectService<SearchComparePatent>(SearchComparePatent);
    const data = await service.searchComparePatent({
        q: query,
        simple: true
    });
    patentInfo.value = data.patent_info;
    isLoading.value = false;
    isNodata.value = _.isEmpty(patentInfo.value);
    if (isNodata.value) return cb([{ isNodata: true }]);

    cb([patentInfo.value]);
}

const selectPatent = (patent:ComparePatentInfo) => {
    const _patentInfo = patent || patentInfo.value
    if (!_patentInfo) return;
    emit('submit', _patentInfo);
}

return { __sfc: true,ElAutocomplete, t, props, emit, inputVal, isLoading, isNodata, patentInfo, searchPatent, selectPatent, PtIcon, Legal }
}

})